/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: HeaderTitle.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 10:18 am.
 * Last modified: 05.07.22 10:18 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { useLobbyHost } from '../contexts/SettingsContext';
import { useTranslator } from '../contexts/TranslatorContext';

const HeaderTitle = ({ icon, label, selected, count, onClickIcon }: IHeaderTitleProps) => {
    const host = useLobbyHost();
    const selectedIcon = selected
        ? `${host}/assets/portal/ui/back.svg`
        : `${host}/assets/portal/icons/${icon.toLowerCase()}.svg`;
    const translate = useTranslator();
    const translatedResultLabel = translate(label || '');

    return (
        <div className={`egt_section_header_title ${selected ? 'section_selected' : ''}`}>
            <img
                className={`icon ${onClickIcon ? 'clickable_icon' : ''} ${selected ? 'back_icon' : ''}`}
                src={addBuildHash(selectedIcon)}
                onClick={onClickIcon}
                alt=""
            />
            <span>
                {translatedResultLabel.toString().toUpperCase()} {selected ? ' (' + count + ')' : ''}
            </span>
        </div>
    );
};

export interface IHeaderTitleProps {
    icon: string;
    label: string;
    selected?: boolean;
    count?: number;
    onClickIcon?: () => void;
}

export default HeaderTitle;
